import {
  Container,
  Grid,
  Text,
  Flex,
  ActionIcon,
  Image,
  Box,
  Group,
  Title,
  Button,
  PinInput,
  useMantineTheme,
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toastSuccess } from '../../config/Helper';
import { ROUTES } from '../../config/RoutesName';
import { otpPageStyle } from './style';
import { toastError } from '../../config/Helper';
import { AxiosResponse, isAxiosError } from 'axios';
import { IBaseResponseError } from '../../typescript/interfaces/common.interface';
import { verifiedIcon } from '../../assets';
import { verifyOTP } from '../../services/otp/otp.service';
import { cartCheckout } from '../../services/cart/cart.service';
import { verifyReceiptOTP } from '../../services/receipt/receipt.service';

const OtpVerification = ({ payment }: { payment?: boolean }) => {
  const theme = useMantineTheme();
  const { classes } = otpPageStyle();
  const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const location = useLocation();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [disableButton, setDisableButton] = useState(true);
  const [activeInput, setActiveInput] = useState(0);
  const [seconds, setSeconds] = useState(30);
  const [showTimer, setShowTimer] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let interval: any = null;
    if (showTimer) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
      if (seconds < 1) {
        setShowTimer(false);
        setSeconds(30);
        clearInterval(interval);
      }
    } else if (!showTimer && seconds !== 0) {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [showTimer, seconds]);

  const resendOTP = async () => {
    if (showTimer) {
      return;
    }
    try {
      const formData = {
        name: location.state.name,
        userEmail: location.state.userEmail,
        userPhone: location.state.userPhone,
        contactType: location.state.contactType === 'email' ? 'email' : 'phone',
      };
      const data = await cartCheckout(formData);
      if (data.success) {
        setShowTimer(true);
        toastSuccess('OTP sent successfully !');
      }
      console.log(data);
    } catch (error: any) {
      console.error(error);
    }
  };

  const onTypeInput = (value: any) => {
    if (value.length === 6) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
    setActiveInput(value);
  };

  const submitOTP = async () => {
    setButtonLoading(true);
    try {
      const formData = {
        otp: activeInput,
        token: location.state.verifyToken,
      };
      const data = await verifyOTP(formData);
      setButtonLoading(false);
      toastSuccess(data?.data?.message);

      if (data?.data?.data?.paid_with_cash) {
        return navigate(ROUTES.ORDERDETAILS + '/' + data?.data?.data?.order_id, {
          state: {
            paid_with_cash: true,
          },
        });
      }

      navigate(ROUTES.PAYMENT, {
        state: {
          orderId: data.data.data.order_id,
          loadStripeSecret: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
          clientSecret: data.data.data.client_secret,
          connect_account_id: data?.data?.data?.connect_account_id,
        },
      });
    } catch (error: unknown) {
      console.error(error);
      if (isAxiosError(error)) {
        const response = error.response as AxiosResponse<IBaseResponseError> | undefined;
        const data = response?.data;
        const hasApiError = data?.data?.error_type && data?.data?.error_message;
        toastError(hasApiError ? data : data?.message);
      }
      setActiveInput(0);
      setDisableButton(true);
      setButtonLoading(false);
    }
  };

  const submitOTPForReceipt = async () => {
    setButtonLoading(true);
    try {
      const formData = {
        otp: activeInput,
      };
      const data = await verifyReceiptOTP(location.state.verifyToken, formData);
      setButtonLoading(false);
      toastSuccess(data.data.message);
      navigate(ROUTES.RECEIPT, { state: data.data });
    } catch (error: unknown) {
      console.error(error);
      if (isAxiosError(error)) {
        const response = error.response as AxiosResponse<IBaseResponseError> | undefined;
        const data = response?.data;
        const hasApiError = data?.data?.error_type && data?.data?.error_message;
        // toastError(hasApiError ? data : data?.message);
      }
      setActiveInput(0);
      setDisableButton(true);
      setButtonLoading(false);
    }
  };

  return (
    <>
      <Container>
        <Grid>
          <Grid.Col span={2} ta='left'>
            <Text fz='16px' fw={500} color={payment ? '#FFFFFF' : 'black'}>
              {location.state.contactType.toUpperCase()} VERIFICATION
            </Text>
          </Grid.Col>
        </Grid>

        <Flex direction='column' align='center' pt={25} pr={'15px'}>
          <ActionIcon size={80} className={classes.iconCard}>
            <Image width='auto' height='auto' src={verifiedIcon} />
          </ActionIcon>
        </Flex>

        <Text align='center' pt={'30px'} fw={500} size={mobile ? '12px' : '14px'} color='#000000'>
          Verification code has been sent by SMS or Email to
        </Text>
        <Text align='center' fw={500} pt={'20px'} size='20px' color='black'>
          {location.state.contactType === 'email' ? location.state.userEmail : location.state.userPhone}
        </Text>

        <Container display={'flex'} style={{ justifyContent: 'center' }}>
          <Box p='15px 0 0 15px' ta={'left'} maw={500}>
            <Text size={mobile ? '11px' : '13px'} fw={450} color='red' pb={'5px'}>
              Enter OTP
            </Text>
            <Group position='center'>
              <PinInput
                type='number'
                onChange={(val) => {
                  onTypeInput(val);
                }}
                className={classes.otpInput}
                radius='14px'
                size='45px'
                spacing={10}
                length={6}
                placeholder=''
                autoFocus
              />
            </Group>

            {showTimer && (
              <Text pt={'15px'} align='center' fw={500} fz='16px' color='red'>
                Send otp in {seconds} seconds
              </Text>
            )}
            <Title pt={'45px'} align='center' fw={500} fz='16px'>
              Didn't receive a code?{' '}
              <Text span c='#fa9418' style={{ cursor: 'pointer' }} inherit onClick={resendOTP}>
                Resend
              </Text>
            </Title>
            {payment && (
              <Title pt={'35px'} align='center' fw={500} fz='16px'>
                Not the correct {location.state.contactType}?{' '}
                <Text
                  span
                  c='#fa9418'
                  style={{ cursor: 'pointer' }}
                  inherit
                  onClick={() => {
                    navigate(ROUTES.CART);
                  }}>
                  Change
                </Text>
              </Title>
            )}

            <Group position='center' pt={'50px'}>
              <Button
                w={'100%'}
                size='xl'
                variant='filled'
                color='red'
                radius='11px'
                style={{ boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.15)' }}
                onClick={payment ? submitOTP : submitOTPForReceipt}
                loading={buttonLoading}
                disabled={disableButton}
                sx={{
                  '&[data-disabled]': {
                    color: 'white',
                    backgroundColor: theme.colors.red[3],
                  },
                }}>
                Submit
              </Button>
            </Group>
          </Box>
        </Container>
      </Container>
    </>
  );
};

export default OtpVerification;
